import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import LoadingSpinner from '@carvana/loading-spinner';
import Button from '@carvana/forms/Button';
import { cvBreakpoint768, ThemeProvider } from '@carvana/theme';

const ButtonWrapper = styled.div`
  min-height: 60px;
  position: relative;

  & > button.loading {
    visibility: hidden;
  }
`;

const ButtonLoadingSpinner = styled(LoadingSpinner)`
  bottom: 0;
  left: 50%;
  position: absolute;
  top: 0;
  transform: translateX(-50%);
`;

const ButtonBase = styled(Button)`
  font-size: 16px;
  min-width: 280px;
  text-transform: ${props => (props.uppercase ? 'uppercase' : 'none')};
  max-width: 300px;
  width: 300px;

  @media (min-width: ${cvBreakpoint768}px) {
    min-width: 160px;
    max-width: 350px;
    width: 320px;
  }
`;

export const CarvanaButtonNoCaps = styled(Button)`
  font-size: 16px;
  font-weight: 500;
  text-transform: none;
`;

const CarvanaButton = ({
  type,
  children,
  color,
  disabled,
  ghost,
  isLoading,
  onClick,
  text,
  uppercase,
  buttonStyles,
  buttonWrapperStyles,
  loadingSpinnerStyles
}) => {
  return (
    <ThemeProvider>
      <ButtonWrapper css={buttonWrapperStyles}>
        {isLoading && <ButtonLoadingSpinner css={loadingSpinnerStyles} />}
        <ButtonBase
          color={color}
          css={buttonStyles}
          className={isLoading && 'loading'}
          disabled={disabled}
          ghost={ghost}
          onClick={onClick}
          uppercase={uppercase}
          type={type}
        >
          {text || children}
        </ButtonBase>
      </ButtonWrapper>
    </ThemeProvider>
  );
};

CarvanaButton.propTypes = {
  disabled: PropTypes.bool,
  children: PropTypes.node,
  color: PropTypes.string,
  ghost: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
  text: PropTypes.string,
  type: PropTypes.string,
  uppercase: PropTypes.bool,
  buttonStyles: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  buttonWrapperStyles: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  loadingSpinnerStyles: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};

CarvanaButton.defaultProps = {
  children: null,
  color: 'primary',
  disabled: false,
  ghost: false,
  isLoading: false,
  onClick: null,
  text: '',
  uppercase: false,
  buttonStyles: null,
  buttonWrapperStyles: null,
  loadingSpinnerStyles: null,
  type: null
};

export default CarvanaButton;
